module.exports = __webpack_public_path__ + "static/team-party-1-f7ea3d522201b73120c05bd1ee82c668.jpg";